// extracted by mini-css-extract-plugin
module.exports = {"outer":"u4tsU","leftWrapper":"_1Aq2C","heading":"_2vGsr","subHeading":"_1k39Q"};